module.exports = __webpack_public_path__ + "static/media/maxbountytv-hero.264fa0e0.jpg";